import React from "react";

import { Checkbox, MenuItem, MenuList, Popover, Typography } from "@mui/material";

export interface ColumnInfo {
  id: string;
  header: string;
}

interface Props {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  columns: ColumnInfo[];
  columnVisibility: Record<string, boolean>;
  onToggle: (columnId: string) => void;
}

export const ColumnManagerPopover: React.FC<Props> = ({ anchorEl, onClose, columns, columnVisibility, onToggle }) => {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "8px",
            width: "203px",
            boxShadow:
              "0px 3px 3px -2px rgba(38,54,70,0.16), 0px 3px 4px 0px rgba(38,54,70,0.1), 0px 1px 8px 0px rgba(38,54,70,0.08)",
            py: "8px"
          }
        }
      }}
    >
      <MenuList disablePadding sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {columns.map((col) => (
            <MenuItem
              key={col.id}
              onClick={() => onToggle(col.id)}
              sx={{
                gap: "8px",
                px: "12px",
                py: "8px",
                minHeight: "unset",
                "&:hover": { bgcolor: "#f6f8fc" }
              }}
            >
              <Checkbox
                checked={columnVisibility[col.id] !== false}
                disableRipple
                sx={{
                  padding: 0,
                  color: "#071f35",
                  "&.Mui-checked": { color: "#071f35" }
                }}
              />
              <Typography sx={{ fontSize: "16px", color: "#071f35", fontWeight: 400, lineHeight: "24px" }}>
                {col.header}
              </Typography>
            </MenuItem>
          ))}
      </MenuList>
    </Popover>
  );
};
